import React from 'react'
import { useParams } from 'react-router-dom'

const LogoEchoSystem = () => {
  const params = useParams()
  const getTenantFromStorage = () => {
    try {
      const storedTenant = JSON.parse(localStorage.getItem('tenant'))
      return storedTenant?.username || null
    } catch {
      return null
    }
  }
  const getTenantFromPath = () => {
    const pathParts = window.location.pathname.split('/').filter(Boolean)
    return pathParts[0] || null
  }
  const tenant = params?.tenant || getTenantFromStorage() || getTenantFromPath()
  const appsBaseUrl = process.env.REACT_APP_WEB_APPS_BASE_URL || 'https://apps.absat-erp.com'
  const getTokenFromUrl = () => {
    const pathParts = window.location.pathname.split('/')
    const tokenIndex = pathParts.indexOf('token')
    if (tokenIndex !== -1 && pathParts[tokenIndex + 1]) {
      return pathParts[tokenIndex + 1]
    }
    const searchParams = new URLSearchParams(window.location.search)
    return searchParams.get('token')
  }
  const getStoredUserToken = () => {
    try {
      const storedUser = JSON.parse(localStorage.getItem('user'))
      return storedUser?.token || storedUser?.accessToken || storedUser?.access_token || null
    } catch {
      return null
    }
  }
  const resolveToken = () => (
    localStorage.getItem('token') ||
    sessionStorage.getItem('token') ||
    getStoredUserToken() ||
    getTokenFromUrl()
  )
  const buildAppsUrl = () => {
    if (!tenant) return appsBaseUrl
    const latestToken = resolveToken()
    if (latestToken) {
      return `${appsBaseUrl}/${tenant}/token/${encodeURIComponent(latestToken)}`
    }
    return `${appsBaseUrl}/${tenant}/dashboard`
  }
  const targetUrl = buildAppsUrl()
  const handleNavigate = (event) => {
    const nextUrl = buildAppsUrl()
    event.preventDefault()
    window.location.assign(nextUrl)
  }
  return (
    <a
      className="flex items-center justify-center"
      href={targetUrl}
      onClick={handleNavigate}
      aria-label="Absat ERP Dashboard"
      title="Absat ERP Dashboard"
    >
      <img src="/logo-white.webp" className="block h-7 w-auto object-contain" alt="Absat ERP" />
    </a>
  )
} 

export default LogoEchoSystem
